(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["da-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('da-size-guide')) {
    class DASizeGuide extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const card = e.target.closest('.da-size-guide__card');
          if (!card) return;
          this.#selectInPicker(card.dataset.optionValue, card.dataset.variantId);
          this.#mark(card.dataset.variantId);
        });
        // Follow the theme's own picker (radio buttons / dropdown)
        const section = this.closest('.shopify-section') || document;
        section.addEventListener('change', (e) => {
          const input = e.target;
          if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLSelectElement)) return;
          if (!input.closest('variant-picker')) return;
          const val = (input.value || '').trim().toLowerCase();
          const card = [...this.querySelectorAll('.da-size-guide__card')].find(
            (c) => (c.dataset.optionValue || '').trim().toLowerCase() === val
          );
          if (card) this.#mark(card.dataset.variantId);
        });
        // Also follow ?variant= in the URL after the theme morphs the section
        window.addEventListener('popstate', () => this.#syncFromUrl());
        const origPush = history.pushState;
        const origReplace = history.replaceState;
        const self = this;
        if (!history.__daPatched) {
          history.__daPatched = true;
          history.pushState = function () { origPush.apply(this, arguments); window.dispatchEvent(new Event('da:urlchange')); };
          history.replaceState = function () { origReplace.apply(this, arguments); window.dispatchEvent(new Event('da:urlchange')); };
        }
        window.addEventListener('da:urlchange', () => self.#syncFromUrl());
      }
      #syncFromUrl() {
        const id = new URL(location.href).searchParams.get('variant');
        if (id) this.#mark(id);
      }
      #mark(variantId) {
        this.querySelectorAll('.da-size-guide__card').forEach((c) => {
          const on = c.dataset.variantId === String(variantId);
          c.classList.toggle('is-selected', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      #selectInPicker(optionValue, variantId) {
        const section = this.closest('.shopify-section') || document;
        const picker = section.querySelector('variant-picker');
        if (!picker) return;
        const want = (optionValue || '').trim().toLowerCase();
        const radio = [...picker.querySelectorAll('input[type="radio"]')].find(
          (r) => (r.value || '').trim().toLowerCase() === want
        );
        if (radio && !radio.checked) {
          radio.click();
          return;
        }
        const select = picker.querySelector('select');
        if (select) {
          const opt = [...select.options].find((o) => (o.value || o.text || '').trim().toLowerCase() === want);
          if (opt) { select.value = opt.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      }
    }
    customElements.define('da-size-guide', DASizeGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
